import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { phoneNumberFormatter } from '../utils/phoneNumberFormatter.mjs';

const SearchResults = ({ applyTransform, className, messages, onAddItem, onContinue, results, selectedResult }) => {
  const [selectedIndex, setSelectedIndex] = useState(selectedResult);

  useEffect(() => {
    setSelectedIndex(selectedResult.index);
  }, [selectedResult]);

  const { _add, _continue, _resultsFound, _title } = messages;

  const handleClick = (index) => setSelectedIndex(index);

  const renderHeader = () => (
    <div className="search-results__header">
      <div>
        <h1>{_title}</h1>
      </div>
      <div className="results-found">
        {`(${results.length} `}{_resultsFound}{')'}
      </div>
    </div>);

  const renderBody = () => (<div className="search-results__body">
    {results.map((result, i) => {
      const isSelected = selectedIndex === i;
      const classes = classnames(
        'result',
        isSelected ? 'selected' : 'unselected'
      );
      const data = applyTransform ? applyTransform(result) : result;
      return (
        <div className={classes} key={`${result.name}_${i}`} onClick={() => handleClick(i)}>
          {isSelected && <i className='fa fa-check-circle checked' />}
          <div className="result__title">
            {data.name && (
              <span>
                <b>{data.name}</b>
              </span>
            )}
          </div>
          {data.address && (
            <div>
              <span>{data.address}</span>
            </div>
          )}
          {(data.city && data.state) && (
            <div>
              <span>{`${data.city}, ${data.state}`}</span>
            </div>
          )}
          {data.phone && (<div>
            <span>{phoneNumberFormatter(data.phone)}</span>
          </div>)}
          {data.email && (<div>
            <span>{data.email}</span>
          </div>)}
        </div>
      );
    })}
  </div>);

  const renderFooter = () => (
    <div className="search-results__footer">
      <button className="btn btn__secondary" aria-label={_add} onClick={onAddItem}>{_add}</button>
      <button className="btn btn__primary" disabled={selectedIndex < 0} aria-label={_continue} onClick={() => onContinue(results[selectedIndex], selectedIndex)}>{_continue}</button>
    </div>
  );

  const classes = classnames(className, 'search-results');

  return (
    <section className={classes}>
      {renderHeader()}
      {renderBody()}
      {renderFooter()}
    </section>
  );
};

SearchResults.propTypes = {
  className: PropTypes.string,
  messages: PropTypes.shape({
    _add: PropTypes.string,
    _continue: PropTypes.string,
    _resultsFound: PropTypes.string,
    _title: PropTypes.string,
  }),
  onAddItem: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  results: PropTypes.arrayOf({}),
  selectedResult: PropTypes.string
};

export default SearchResults;